import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";
import api, { apiErr } from "../api";
import { FounderShell, RangeBar, MetricCard, DistBars } from "../components/founder";

export default function Founder() {
  const [range, setRange] = useState("last_30_days");
  const [tz, setTz] = useState("America/New_York");
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get(`/founder/overview?range=${range}&tz=${encodeURIComponent(tz)}`)
      .then((r) => setData(r.data)).catch((e) => toast.error(apiErr(e)));
  }, [range, tz]);
  useEffect(() => { load(); }, [load]);

  const k = data?.kpis || {};
  return (
    <FounderShell>
      <div className="space-y-4" data-testid="founder-overview-page">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Executive Overview</h1>
        <RangeBar range={range} setRange={setRange} tz={tz} setTz={setTz} meta={data ? { label: data.range?.label, generated_at: data.generated_at } : null} />

        {!data ? <div className="ff-panel rounded-md p-8 text-center text-ff-muted">Loading command center…</div> : (
          <>
            <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="founder-kpi-grid">
              <MetricCard label="Total Players" metric={k.total_registered} testid="kpi-total" />
              <MetricCard label="Active Today" metric={k.active_today} testid="kpi-active-today" />
              <MetricCard label="Active 7d" metric={k.active_7d} testid="kpi-active-7d" />
              <MetricCard label="Active 30d" metric={k.active_30d} testid="kpi-active-30d" />
              <MetricCard label="New Today" metric={k.new_registrations_today} testid="kpi-new-today" />
              <MetricCard label="New This Week" metric={k.new_registrations_week} testid="kpi-new-week" />
              <MetricCard label="Day-1 Retention" metric={k.day1_retention} suffix="%" testid="kpi-d1" />
              <MetricCard label="Day-7 Retention" metric={k.day7_retention} suffix="%" testid="kpi-d7" />
              <MetricCard label="Day-30 Retention" metric={k.day30_retention} suffix="%" testid="kpi-d30" />
              <MetricCard label="Avg Session" metric={k.avg_session_duration_sec} suffix="s" testid="kpi-session" />
              <MetricCard label="Expeditions Started" metric={k.expeditions_started} testid="kpi-exp-started" />
              <MetricCard label="Expeditions Completed" metric={k.expeditions_completed} testid="kpi-exp-completed" />
              <MetricCard label="Completion Rate" metric={k.expedition_completion_rate} suffix="%" testid="kpi-completion" />
              <MetricCard label="Daily Ranked" metric={k.daily_ranked_participation} testid="kpi-daily-ranked" />
              <MetricCard label="Daily Practice" metric={k.daily_practice_participation} testid="kpi-daily-practice" />
              <MetricCard label="Avg Stake" metric={k.avg_stake} testid="kpi-avg-stake" />
              <MetricCard label="Gold in Circulation" metric={k.gold_in_circulation} testid="kpi-gold" />
              <MetricCard label="Active Season" metric={k.active_season} testid="kpi-season" />
              <MetricCard label="Leaderboard Eligible" metric={k.leaderboard_eligible} testid="kpi-eligible" />
              <MetricCard label="Rival Follows" metric={k.rival_follows} testid="kpi-follows" />
              <MetricCard label="Notification Open Rate" metric={k.notification_open_rate} suffix="%" testid="kpi-notif" />
              <MetricCard label="Cards Generated" metric={k.explorer_cards_generated} testid="kpi-cards" />
              <MetricCard label="Card Downloads" metric={k.card_downloads} testid="kpi-card-dl" />
              <MetricCard label="Hall Participation" metric={k.hall_of_renown_participation} testid="kpi-hall" />
              <MetricCard label="Sponsor Page Views" metric={k.sponsor_page_views} testid="kpi-sponsor-v" />
              <MetricCard label="Earn Page Views" metric={k.earn_page_views} testid="kpi-earn-v" />
            </div>

            <div className="grid gap-4 md:grid-cols-2">
              <div className="ff-panel rounded-md p-5" data-testid="founder-prestige-dist">
                <h2 className="mb-3 text-lg font-semibold text-ff-gold">Prestige Tier Distribution</h2>
                <DistBars dist={k.prestige_tier_distribution} testid="prestige-dist-bars" />
              </div>
              <div className="ff-panel rounded-md p-5" data-testid="founder-journey-dist">
                <h2 className="mb-3 text-lg font-semibold text-ff-gold">Explorer Journey Stages <span className="text-[11px] text-ff-muted">(preview)</span></h2>
                <DistBars dist={k.journey_stage_distribution} testid="journey-dist-bars" />
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <Link to="/founder/analytics" data-testid="goto-analytics" className="inline-flex items-center gap-1.5 rounded-sm border border-ff-brass/30 px-3 py-2 text-sm text-ff-brass hover:border-ff-gold hover:text-ff-gold">Deep Analytics <ArrowRight size={14} /></Link>
              <Link to="/founder/reports" data-testid="goto-reports" className="inline-flex items-center gap-1.5 rounded-sm border border-ff-brass/30 px-3 py-2 text-sm text-ff-brass hover:border-ff-gold hover:text-ff-gold">Reports <ArrowRight size={14} /></Link>
              <Link to="/founder/system-health" data-testid="goto-health" className="inline-flex items-center gap-1.5 rounded-sm border border-ff-brass/30 px-3 py-2 text-sm text-ff-brass hover:border-ff-gold hover:text-ff-gold">System Health <ArrowRight size={14} /></Link>
            </div>
          </>
        )}
      </div>
    </FounderShell>
  );
}
